<template>
  <PageLayout class="custom-poll-page mb">
    <template slot="header">
      <div class="header-wrap m-3 mx-lg-0">
        <breadcrumb :list="breadcrumbList" />
        <b-button
          v-if="$can('create', 'customPoll')"
          variant="tertiary"
          class="medium btn-custompoll-new"
          :to="{ name: 'customPoll.new' }"
        >
          <i class="material-icons">add_circle</i>
          {{ label.create }}
        </b-button>
      </div>
    </template>
    <template slot="main">
      <div>
        <dashboard-custom-poll
          v-if="$can('see', 'customPoll.report')"
          :polls="polls"
          :currentTab="currentTab"
          @changeStatus="statusChange"
          @changeOwner="ownerChange"
        />

        <b-pagination
          v-if="currentCountPolls > query.perPage && !loading"
          v-model="query.page"
          :total-rows="currentCountPolls"
          :per-page="query.perPage"
          align="center"
          class="mt-4"
          @input="statusChange(currentTab)"
        >
        </b-pagination>

        <!-- Modal Plans -->
        <modal-plans
          ref="component-modal-plans"
          :title="label.modalPlansTitle"
          :hideHeaderClose="true"
          :visible="true"
          v-if="!$can('see', 'customPoll.report')"
          @hide="handleHide"
        />
        <!-- END - Modal Plans -->
      </div>
    </template>
  </PageLayout>
</template>

<script>
import { mapGetters } from 'vuex'
import PageLayout from '@/components/Home/PageLayout.vue'
import DashboardCustomPoll from '@/components/CustomPoll/DashboardCustomPoll.vue'
import ModalPlans from '@/components/Modal/ModalPlans.vue'
import ability from '@/helpers/ability'
import Breadcrumb from '@/components/Shared/Breadcrumb.vue'
import { STATUS_ACTIVE, OWNER_MY } from '@/components/CustomPoll/Enum.js'

export default {
  components: {
    PageLayout,
    DashboardCustomPoll,
    ModalPlans,
    Breadcrumb,
  },
  data() {
    return {
      owner: OWNER_MY,
      currentTab: STATUS_ACTIVE,
      query: {
        page: 1,
        perPage: 20,
      },
    }
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
      polls: 'customPoll/polls',
      currentCountPolls: 'customPoll/currentCountPolls',
      loading: 'customPoll/loading',
    }),
    label() {
      return this.resources.page.customPoll
    },
    breadcrumbList() {
      return [
        {
          label: this.resources.page.home.customPoll.title,
        },
      ]
    },
    userRole() {
      return this.$store.getters['user/user'].role
    },
  },
  created() {
    this.$store.dispatch('customPoll/loadPollList', {
      status: this.currentTab,
      owner: OWNER_MY,
      offset: this.query.perPage * (this.query.page - 1),
      limit: this.query.perPage,
    })
  },
  mounted() {
    this.$root.$emit('setPageTitle', { context: this, path: 'customPoll' })
    this.$ability.update(ability().rules)
  },
  methods: {
    statusChange(status) {
      if (status !== this.currentTab) {
        this.query.page = 1
      }

      this.$store.dispatch(`customPoll/loadPollList`, {
        status: status,
        owner: this.owner,
        offset: this.query.perPage * (this.query.page - 1),
        limit: this.query.perPage,
      })

      this.currentTab = status
    },
    ownerChange(owner) {
      this.owner = owner
    },
    handleHide($event) {
      this.$router.push({ name: 'dashboard' })
      $event.preventDefault()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/variables';

.custom-poll-page {
  .btn-custompoll-new {
    height: $btn-height;
    padding: 0.7rem 1rem 0.5rem;

    i {
      display: inline-block;
      font-size: 16px;
      line-height: 16px;
      vertical-align: text-top;
    }
  }
  .header-wrap {
    display: flex;
    justify-content: space-between;
  }
}
</style>
